import { useChooseContext } from "../context/ChooseContext";
import { useSelectEarthquakeContext } from "../context/SelectEarthquakeContext";

export default function Coordinate() {
  const [state] = useSelectEarthquakeContext();
  const [choose] = useChooseContext();
  return (
    <>
      {state.isLoading ? (
        ""
      ) : (
        <div className="flex flex-col items-start min-[1010px]:flex-row gap-5 absolute bottom-16 left-3 min-[1010px]:left-20  min-[1010px]:top-[11px]">
          <div className="px-4 py-2 shadow-[0_7px_29px_0px_rgba(100,100,111,0.3)] z-10 bg-white cursor-pointer text-sm rounded w-auto">
            <span className="font-medium">Koordinat : </span>
            <span>
              {choose.isRecent
                ? `${state.recentEarthquake.Lintang} - ${state.recentEarthquake.Bujur}`
                : `${state.selectedEarthquake.Lintang} - ${state.selectedEarthquake.Bujur}`}
            </span>
          </div>

          <div className="px-4 py-2 shadow-[0_7px_29px_0px_rgba(100,100,111,0.3)] z-10 bg-white cursor-pointer text-sm rounded w-auto">
            <span className="font-medium">Kedalaman : </span>
            <span>
              {choose.isRecent
                ? state.recentEarthquake.Kedalaman
                : state.selectedEarthquake.Kedalaman}
            </span>
          </div>
        </div>
      )}
    </>
  );
}
